import { TooltipPosition } from './types'

/** For usage in JS files */
export const TOOLTIP_POSITIONS_ENUM: Record<TooltipPosition, TooltipPosition> = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
  right_bottom: 'right_bottom',
  left_bottom: 'left_bottom',
}

/** Tooltip position fallback priorty defined by design */
export const TOOLTIP_POSITIONS_PRIORITY: TooltipPosition[] = ['top', 'bottom', 'right', 'left']

export const DEFAULT_TOOLTIP_POSITION: TooltipPosition = 'top'
